
import { Lead } from '../../pages/pdf/types';

interface Props {
  data: Lead;
}

export const PdfLead = ({ data }: Props) => {
  const { leadTitle } = data;
  const { content } = data;




return (
    <div >
      <h2 className='mt-4 mb-2 px-2 text-3xl'>{leadTitle}</h2>
      <p className='px-2'>{content}</p>
    </div>
  );
};